import { createEffect, createEvent, createStore, sample } from 'effector';
import { safeLocalStorage } from '../../shared/lib/safe-storage';

/*
 * The tour (docs/PLAN.md §2.5): three coach marks — the variants tree, the charts and the command
 * palette. It starts from the help center ("Take the tour", which a new visitor sees first), the
 * Help menu or the palette; it never starts by itself.
 */

export const TOUR_STEPS = ['tree', 'charts', 'palette'] as const;
export type TourStep = (typeof TOUR_STEPS)[number];

const DONE_KEY = 'finsim:tour-done';

export const tourStarted = createEvent();
export const tourNext = createEvent();
export const tourEnded = createEvent();

export const $tourStep = createStore<number | null>(null)
  .on(tourStarted, () => 0)
  .on(tourNext, (step) => (step === null || step >= TOUR_STEPS.length - 1 ? null : step + 1))
  .reset(tourEnded);

// Seen once is enough, whether finished or skipped.
const markSeenFx = createEffect(() => {
  safeLocalStorage.setItem(DONE_KEY, '1');
});
sample({ clock: tourStarted, target: markSeenFx });
